module.exports = __webpack_public_path__ + "img/g4.2fc309de.jpg";